<template>
    <div class="container inactive">
        <BackButton
                defaultText="back-to-list"
                defaultRoute="/studios/members"
        />
        <div class="attention">
            <div class="attention__pic"><img src="@/assets/images/dashboard/info.svg" alt=""></div>
            <div class="attention__text" v-html="$t('studio.inactive-members.info_title')"></div>
        </div>
        <div class="info-in">
            <div class="info-in__title">
                {{$t('studio.inactive-members.cases_title')}}
            </div>
            <div class="info-in__list">
                <div class="info-in__item"
                     v-for="(item,i) in info"
                     :key="i"
                >
                    {{$t(`studio.inactive-members.${item}`)}}
                </div>
            </div>
            <div class="info-in__sub" v-html="$t('studio.inactive-members.cases_text')">
            </div>
        </div>

        <Table
                :table-head="header"
                :table-body="body"
                :tableData="tableData"
                :allowTooltip="true"
                :isHover="false"
                :request-function="getInactiveMembers"
                more-mode="mobile"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    // import Table from "@/elements/Table/Table";
    import { getInactiveMembers } from "@/api/studioServices";
    import Table from "@/elements/Table/Table";

    export default {
        components: {
            Table
            // Table,
        },

        data() {
            return {
                info: ['email_wrong', 'email_spam', 'member_delete'],
                getInactiveMembers: getInactiveMembers,
            }
        },

        computed: {
            ...mapGetters([
                'tableData',
            ]),

        header() {
            return [
                {
                    name: 'email',
                    adaptiveMode: 'mobile',
                    width: '300px'
                },
                {
                    name: 'confirmation_date',
                    adaptiveMode: 'tablet',
                    width: '300px'
                },
                {
                    name: 'tooltip',
                    adaptiveMode: 'tablet',
                    width: '15px'
                },
            ]
        },

        body() {
            let arr = [];
                this.tableData.data && this.tableData.data.forEach(item => {
                    arr.push({
                        email: item.email,

                        confirmation_date: item.created_at,
                        tooltip: {
                            id: item.id
                        }
                })
            });
                return arr;
        }
    },

    async created() {
        await this.$store.dispatch('PAGINATE', {page: 1, requestFunction: this.getInactiveMembers});
    },
    }
</script>

<style lang="sass" scoped>
    .info-in
        +reg
        color: $color--dark-lighten
        font-size: 14px
        line-height: 18px
        margin-left: 36px
        &__title
            +semi
            margin: 8px 0 4px 0
        &__sub
            margin-top: 8px
        &__item
            position: relative
            padding-left: 14px
            &:before
                content: ''
                z-index: 1
                display: block
                position: absolute
                top: 50%
                left: 0
                transform: translateY(-50%)
                background: linear-gradient(270deg, #1D6ADC 3.61%, #4277FF 104.62%)
                box-shadow: 0px 2px 4px rgba(67, 73, 233, 0.25)
                width: 6px
                height: 6px
                border-radius: 50%
        +r(599)
            text-align: justify
    .inactive
        .attention
            +r(599)
                flex-direction: row
                align-items: flex-start
                text-align: justify
                &__text
                    margin-left: 12px
</style>